/**
 * Copyright-safe athlete atmosphere plates for Hero + My Arena + action cards.
 * Stock: Unsplash / Pexels (no team/league marks). Custom plates for lock/battle ghosts.
 */
import heroBoxing from './hero-boxing.jpg';
import heroBasketball from './hero-basketball.jpg';
import heroAllSports from './hero-all-sports.png';
import arenaBoxing from './arena-boxing.jpg';
import arenaRunner from './arena-runner.jpg';
import ghostPadlock from './ghost-padlock.png';
import ghostArenaBattle from './ghost-arena-battle.png';

export const ATHLETE_ATMOSPHERE = Object.freeze({
  /** All-sports triptych — desktop hero only */
  heroAllSports,
  heroPrimary: heroBoxing,
  heroSecondary: heroBasketball,
  arenaAccent: arenaBoxing,
  arenaMotion: arenaRunner,
  ghostPadlock,
  ghostArenaBattle,
  pageGhost: ghostPadlock,
});
